import React from 'react';

const Logo = ({ className = "w-8 h-8" }) => {
    return (
        <svg 
            className={`${className} select-none`}
            viewBox="0 0 36 36" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient id="cortexGradPrimary" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#6366f1" />
                    <stop offset="50%" stopColor="#8b5cf6" />
                    <stop offset="100%" stopColor="#06b6d4" />
                </linearGradient>
                <linearGradient id="cortexGradCore" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#a855f7" />
                    <stop offset="100%" stopColor="#3b82f6" />
                </linearGradient>
                <filter id="cortexGlow" x="-30%" y="-30%" width="160%" height="160%">
                    <feGaussianBlur stdDeviation="2" result="blur" />
                    <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
            </defs>
            
            {/* Outer dynamic orbital ring representing distributed agents */}
            <circle 
                cx="18" 
                cy="18" 
                r="16" 
                stroke="url(#cortexGradPrimary)" 
                strokeWidth="1.5" 
                strokeDasharray="6 3" 
                className="animate-spin-slow" 
                style={{ transformOrigin: 'center' }} 
                strokeOpacity="0.8"
            />

            {/* Inner Hexagonal Coordination Framework */}
            <path 
                d="M18 6L28 12V24L18 30L8 24V12L18 6Z" 
                stroke="url(#cortexGradPrimary)" 
                strokeWidth="1.2" 
                strokeOpacity="0.4"
                strokeLinejoin="round"
            />

            {/* Neural Central Node Connections */}
            <path 
                d="M18 11V25M11.9 14.5L24.1 21.5M11.9 21.5L24.1 14.5" 
                stroke="url(#cortexGradPrimary)" 
                strokeWidth="1.2" 
                strokeOpacity="0.6"
                strokeLinecap="round"
            />
            
            {/* Central Glowing Processor Node */}
            <circle 
                cx="18" 
                cy="18" 
                r="4.2" 
                fill="url(#cortexGradCore)" 
                filter="url(#cortexGlow)" 
            />
            <circle cx="18" cy="18" r="2" fill="#ffffff" />
            
            {/* Outer Node Satellites (Agents: Planner, RAG, Tool, Critic) */}
            <circle cx="18" cy="6" r="1.8" fill="#6366f1" />
            <circle cx="28" cy="12" r="1.8" fill="#06b6d4" />
            <circle cx="28" cy="24" r="1.8" fill="#8b5cf6" />
            <circle cx="18" cy="30" r="1.8" fill="#3b82f6" />
            <circle cx="8" cy="24" r="1.8" fill="#10b981" />
            <circle cx="8" cy="12" r="1.8" fill="#f43f5e" />
        </svg>
    );
};

export default Logo;
